/**
 * FE helpers for Adelanto NEX amounts and benefit display.
 *
 * Monto NEX is calculated by backend (`importe_nex_calculado` on GET contrato,
 * `importe_nex` on iniciarpago response). FE must not derive it from
 * unidades_por_periodo.
 */

export const getAdelantoPrimaryBenefit = (version) => {
    const benefits = version?.contrato_v_beneficio ?? [];
    return benefits.find((b) => Number(b?.beneficio) > 0) ?? benefits[0] ?? null;
};

export const getAdelantoProductLabel = (benefit, product_families) => {
    if (benefit?.denominacion) return benefit.denominacion;
    const productoId = benefit?.producto;
    if (productoId == null || productoId === '') return null;
    const product = product_families
        ?.flatMap((family) => family?.products ?? [])
        ?.find((candidate) => String(candidate?.id) === String(productoId));
    return product?.denominacion ?? null;
};

/** Product FK for iniciarpago — `contrato_v_beneficio[].producto` (not producto_ref). */
export const getAdelantoProductId = (version) => {
    const benefit = getAdelantoPrimaryBenefit(version);
    const producto = benefit?.producto;
    return producto != null && producto !== '' ? producto : null;
};

/** V2 backend field is unidades_por_periodo (labelled "Unidades por compra"). */
export const getAdelantoCommittedUnits = (version) => {
    const units = Number(version?.unidades_por_periodo ?? version?.unidades_por_compra ?? 0);
    return Number.isFinite(units) && units > 0 ? units : 0;
};

/** Backend `contrato_version[].importe_nex_calculado` (tipo 9 only). */
export const getImporteNexCalculado = (version) => {
    const raw = version?.importe_nex_calculado;
    if (raw == null || raw === '') return null;
    const normalized = String(raw).trim().replace(',', '.');
    const n = Number(normalized);
    return Number.isFinite(n) && n > 0 ? n : null;
};

export const formatAdelantoBenefitLabel = (benefit) => {
    if (!benefit) return '—';
    const { tipo_beneficio: type, beneficio: value } = benefit;
    const n = Number(value);
    if (!type || Number.isNaN(n) || n < 0) return '—';
    if (type === 'F') {
        return new Intl.NumberFormat('es-AR', {
            style: 'currency',
            currency: 'ARS',
            minimumFractionDigits: 2,
        }).format(n);
    }
    if (n <= 100) return `${n} %`;
    return '—';
};

export const formatAdelantoNexAmount = (amount) => {
    if (amount === null || amount === undefined || Number.isNaN(amount)) return '—';
    return new Intl.NumberFormat('es-AR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(amount);
};
